const PASSWORD_HAS_LETTER_AND_NUMBER = /^(?=.*[a-zA-Z])(?=.*\d).+$/;

export function validateRequiredPasswordChange({
  currentPassword = '',
  password = '',
  passwordConfirmation = '',
} = {}) {
  const errors = {};

  if (!currentPassword) {
    errors.current_password = 'Debes indicar la contraseña vigente.';
  }

  if (!password) {
    errors.password = 'Debes indicar una contraseña';
  } else if (password.length < 8) {
    errors.password = 'La contraseña debe tener al menos 8 caracteres';
  } else if (password.length > 32) {
    errors.password = 'La contraseña no puede superar los 32 caracteres';
  } else if (!PASSWORD_HAS_LETTER_AND_NUMBER.test(password)) {
    errors.password = 'La contraseña debe contener al menos una letra y un número';
  }

  if (password && passwordConfirmation !== password) {
    errors.password_confirmation = 'La confirmación de contraseña no coincide';
  }

  return errors;
}
